module.exports = __webpack_public_path__ + "static/sportsconnectmyaccount-132adaa83d603051ae5a42d21e5d5dfd.png";